const Icon7 = ({className = '', ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="57"
    height="57"
    fill="none"
    viewBox="0 0 57 57"
    className={className}
      {...props}
  >
    <path
      fill="url(#pattern0_151_1081)"
      d="M.762.72h56.076v56.076H.762z"
    ></path>
    <defs>
      <pattern
        id="pattern0_151_1081"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_151_1081" transform="scale(.01111)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAElElEQVR4nO2dbWiWVRjHT6ZGmGbBEgPxBSqRSDQkxAw/mC+Bgz5NEEPF9eJsERrhG0h+KPDDyvrQVBAXivphigM/+DIEC2FTZxLbWiGC5hphsk1Lp+4Xh+d8GLlnu+/nuc99nXOf5wf7tO0+/+vPs3Ofc53rOlOqRIkSJfwEeAH4AbhlvuqAMmldmQJ4CmjlcX7R35PWlxmAavJTLa0vEwBPAL8OYfRvwAhpnd4DLGJ43pbW6T3A0QhG10vr9BpgEvAggtEPgcnSer0F2EF0vpDW6yXAKOCPGEZ3AqOldXsHsJz4VEjr9g7gXAFGn5PW7RXAXApnnrR+bwBOFGF0g7R+LwDeBPopjgXScTgN8CTwM8Wjk00jpeNxFuAzkmODdDxOArwO3E/Q6HvALOm4nAJ4FuggedqBcdLxubQDPIk9GoM/HNB5ZHM8ZZv9weaszQpjH+lxQP/1qJAAxgDHSZ9jemwVAsDLwBXkaANmqIyf/a0BupGnG1itNaksAUwHzuIejcAryneAKUBtxOMoKR4BR4CXlG8Ac4CDjhv8fx4YzXOUB2viZcAp/OcC8J5TiSngGeB98zbPGleBz4HxkgZPBLabgsOs0wN8k2pJg1mm6TKAPsKjT5c1pLIsBD6WjtYBqtIweqiCw1BoS8Pof6WjdIB/0jBaMk/hCpfTMHqldJQOsMK60cbsKrPkCY0e4KNUTB5g9ljgE+Aa2eem2TM8n6rJebbeP5E9Lpqt+CgXSwbqPEsmDZbNawAWKtcBpgI1ns3jPcDXwDTlG2Ye10mZ27hLL/CV6PybFDoIYHcCxYtJ0m8OJfw3OE+lqI2KpLh0ZL6O2kwnh5HjmGh+OU1MqnWrwFSxWYUIsCqlpeBD4AMVMsBayy/Jfl1PIh2nE1ieRjZJx+cU5IoQk6ZOOi7nIHea3pbwEm6sdFxOQi5Xol9cxaJfsLMtfyiOmm17vZcVqsCuBIyusaxRp0wHsl152s/yZxEmd9rsW8lzGYCfDf/AxiKM/tSytorMNPyT6wjoKsDkv/T8aVnb+TxjN6mA1tZbLWtaOsz4i5VvAGW6fiJmA+cEi3pGR1h+tjp37BUFYG8Mo/dY1rIzoo4vlW8Ar8bIg7xmUce75iwxCvrnypVvAGciBHfa4vjzY05hmrveHSwA5RECW2Zp7HeMaYVwB1iiPDskaE/zykzT1bstgXSA/v0t+nnKBxi6Jnt9wmO9ATSTLE3ONyENWFpdHiSAS0ltfc1crAtnbNFvnj9feVCyUAvcAK4D3wPPJTAtVVj4BA9Hsxk3W527+QC+Q5ZdKgQofEWRFL0qBMjdJibJFRUCwEygRcjkFpu7WZdL1RpSqg380dSTh/EiHCK3ctiC4fp5h/TzBx04VIC3EuynbHd+7exAMaa+x6MYDtk+8ckE5DY0utm+EGqCnocLAfg2psm1BQ0UOsDIGHdCNXqTrXMR4MUIvTh/63tMpLV6D7BuGKM/lNaYCcgdCOTrwfndqTuYfAeozGN0pbS2LP5vxa5BKqSeltYWwr+W2iGtKZOQq48+bvLZup2utPsrUaKEEuI/cdqbaEnZEI4AAAAASUVORK5CYII="
        id="image0_151_1081"
        width="90"
        height="90"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
);

export default Icon7;
